import { z } from "zod";

export const PasswordResetRequestIn = z.object({
  email: z.string(),
});

export const PasswordResetConfirmIn = z.object({
  token: z.string(),
  password: z.string(),
  password_confirm: z.string(),
});

export const PasswordResetInfoOut = z.object({
  email: z.string(),
});

export const PasswordResetSuccessOut = z.object({
  success: z.boolean(),
  message: z.string(),
});
